import { SchemaOverview } from "@/components/templates/SchemaOverview";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/$organizationKey/$dossierId/$researchProjectId/results/$researchParticipationId/$schemaId/schema"
)({
  component: SchemaPage,
});

function SchemaPage() {
  const { researchParticipationId, schemaId } = Route.useParams();

  return <SchemaOverview responseId={schemaId} researchParticipationId={researchParticipationId} />;
}
